module.exports = __webpack_public_path__ + "static/img/doncuco-food.e559a47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/doncuco-food.jpg
// module id = Uinq
// module chunks = 0